export const NavigationContainer = `fixed bg-darkGrey top-[80px] left-0 h-[66px] w-full z-20 flex justify-center items-center py-4 w-full`
export const SectionsWrapper = 'xl:container px-10 w-full flex justify-between items-center'
export const LeftSection = `w-1/4`
export const MiddleSection = `w-1/2 flex justify-center`
export const RightSection = `w-1/4 flex flex-row justify-end inline-flex items-center`
export const SpaceFiller = `h-[66px] w-full`
